export const environment = {
  production: false,
  apiUrl: 'https://direct-pub-api.directgh.com',
  apiVersion: 'v1',
  appName: 'CyTech 360 Back Office (Dev)',
  appVersion: '2.0.0-dev',
  enableDebugTools: true,
};

